import React, { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./News.css";

import img1 from "../../images/teachersday/img (1).jpeg";
import img2 from "../../images/teachersday/img (2).jpeg";
import img3 from "../../images/teachersday/img (3).jpeg";
import img4 from "../../images/teachersday/img (4).jpeg";
import img5 from "../../images/teachersday/img (5).jpeg";
import img6 from "../../images/teachersday/img (6).jpeg";
import img7 from "../../images/teachersday/img (7).jpeg";
import img8 from "../../images/teachersday/img (8).jpeg";
import img9 from "../../images/teachersday/img (9).jpeg";
import img10 from "../../images/teachersday/img (10).jpeg";
import img11 from "../../images/teachersday/img (11).jpeg";
import img12 from "../../images/teachersday/img (12).jpeg";
import img13 from "../../images/teachersday/img (13).jpeg";
import img14 from "../../images/teachersday/img (14).jpeg";
import img15 from "../../images/teachersday/img (15).jpeg";
import img16 from "../../images/teachersday/img (16).jpeg";




const TeachersDayGallery = ({ isOpen, setIsOpen }) => {
  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "unset";
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);

  return (
    isOpen && (
      <div className="gallery">
        <div className="gallery-modal">
          <div className="close-button" onClick={closeModal}>
            <i class="far fa-times" />
          </div>
          <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            autoPlay={true}
            infiniteLoop={true}
          >
            <div>
              <img src={img1} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img2} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img3} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img4} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img5} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img6} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img7} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img8} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img9} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img10} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img11} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img12} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img13} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img14} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img15} alt="" className="carousel-image" />
            </div>
            <div>
              <img src={img16} alt="" className="carousel-image" />
            </div>
          </Carousel>
        </div>
      </div>
    )
  );
};

export default TeachersDayGallery;
